/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ConfrontationInfoDto } from './confrontationInfoDto';
import { MapAddressDto } from './mapAddressDto';
import { MovablesDto } from './movablesDto';
import { PositionablesDto } from './positionablesDto';

export interface SquareDto { 
    uuid?: string;
    name?: string;
    names?: { [key: string]: string; };
    descriptions?: { [key: string]: string; };
    visible?: boolean;
    address?: MapAddressDto;
    terrain?: SquareDto.TerrainEnum;
    trade?: number;
    production?: number;
    culture?: number;
    coins?: number;
    calculatedTrade?: number;
    calculatedProduction?: number;
    calculatedCulture?: number;
    calculatedCoins?: number;
    calculatedCombatBonuses?: number;
    resource?: string;
    townPlaceholder?: SquareDto.TownPlaceholderEnum;
    positionable?: PositionablesDto;
    movables?: MovablesDto;
    confrontation?: boolean;
    confrontationInfo?: ConfrontationInfoDto;
}
export namespace SquareDto {
    export type TerrainEnum = 'Mountain' | 'Forest' | 'Grassland' | 'Desert' | 'Water';
    export const TerrainEnum = {
        Mountain: 'Mountain' as TerrainEnum,
        Forest: 'Forest' as TerrainEnum,
        Grassland: 'Grassland' as TerrainEnum,
        Desert: 'Desert' as TerrainEnum,
        Water: 'Water' as TerrainEnum
    };
    export type TownPlaceholderEnum = 'Hut' | 'Village';
    export const TownPlaceholderEnum = {
        Hut: 'Hut' as TownPlaceholderEnum,
        Village: 'Village' as TownPlaceholderEnum
    };
}